import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from 'src/app/core/services/helper.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-tfg-payment-reversal',
  templateUrl: './tfg-payment-reversal.component.html',
  styleUrls: ['./tfg-payment-reversal.component.css']
})
export class TfgPaymentReversalComponent implements OnInit {
  tfgRequest: any;
  transaction: any;
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<TfgPaymentReversalComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private helperService: HelperService,
    private notificationService: NotificationService,
  ) {
    this.tfgRequest = data;
    this.form = fb.group({
      requestId: [null, Validators.compose([Validators.required])],
      approvedByEmail: [null, Validators.compose([Validators.required, Validators.email])],
      approvedByPwd: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.baseService.executeCommand('portal_tfg_account_payment_reversal_config', this.tfgRequest)
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.transaction = response.data;
            this.form.controls['requestId'].setValue(this.transaction.requestId);
          } else {
            this.dialogRef.close(false);
          }
        },
        error => {
          this.dialogRef.close(false);
        })
  }

  save() {
    let body = this.form.getRawValue();
    body.approvedByPwd = this.helperService.hash(body.approvedByPwd);
    const dialogData: OiGroupDialogData = {
      title: 'Reversing TFG Account Payment',
      function: 'portal_oi_group_payment_tfg_account__payment_reversal',
      postBody: body
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      this.dialogRef.close(false);
    });
  }

}
